import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Role } from './role';
import { Area } from '../../core/constants/area';

@Injectable()
export class RolesService {
  
  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Role[]> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/roles`;    
    return this.httpClient.get<Role[]>(url);
  }

  public getUserRoles(email: string): Observable<string[]> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/roles?email=${email}`;    
    return this.httpClient.get<string[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/roles/roles.service.ts